import { useState, useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Flex, Heading, Button, Text, useToast } from "@chakra-ui/react";
import { LockIcon, UnlockIcon } from "@chakra-ui/icons";

// services
import { ApiService } from "../../service/api-service";

// components
import { CustomInputComponent } from "../../components/input/CustomInputComponent";

// validations
import { isSafePassword } from "../../util/validations";

export const PasswordRecoveryComponent = () => {
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const toast = useToast();

    const oobCode = searchParams.get("oobCode") ?? "";

    const [loading, setLoading] = useState(false);
    const [sendData, setSendData] = useState({
        password: "",
        confirmPassword: "",
    });
    const [validSendData, setValidSendData] = useState({
        password: "",
        confirmPassword: "",
    });

    const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();

        const validData = {
            password: "",
            confirmPassword: "",
        };

        if (sendData.password === "") {
            validData.password = "Ingrese su nueva contraseña";
        } else if (!isSafePassword(sendData.password)) {
            validData.password =
                "La contraseña debe tener 8 carácteres, 1 mayúscula, 1 minúscula, 1 número y 1 carácter especial";
        } else if (sendData.password !== sendData.confirmPassword) {
            validData.password = "Las contraseñas no coinciden";
        }

        if (sendData.confirmPassword === "") {
            validData.confirmPassword = "Confirme su nueva contraseña";
        } else if (!isSafePassword(sendData.confirmPassword)) {
            validData.confirmPassword =
                "La contraseña debe tener 8 carácteres, 1 mayúscula, 1 minúscula, 1 número y 1 carácter especial";
        } else if (sendData.password !== sendData.confirmPassword) {
            validData.confirmPassword = "Las contraseñas no coinciden";
        }

        setValidSendData(validData);

        setTimeout(() => {
            setValidSendData({ password: "", confirmPassword: "" });
        }, 2000);

        if (Object.values(validData).every((item) => item === "")) {
            recoverPassword();
        }
    };

    const recoverPassword = async () => {
        try {
            setLoading(true);

            await ApiService.changePassword(oobCode, sendData.password);

            toast({
                title: "Contraseña restablecida con éxito",
                description:
                    "Ahora puede iniciar sesión con su nueva contraseña.",
                status: "success",
                duration: 4000,
                isClosable: true,
                position: "top-right",
            });

            navigate("/");
        } catch (error: any) {
            console.log("error on recover password", error);

            toast({
                title: error.message || "Error al cambiar la contraseña",
                description: "Por favor, inténtalo de nuevo",
                status: "error",
                duration: 4000,
                isClosable: true,
                position: "top-right",
            });
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (!oobCode) {
            navigate("/");
        }
    }, [navigate, oobCode]);

    return (
        <Flex
            alignItems="center"
            justifyContent="center"
            flexDirection={"column"}
            padding={4}
            minHeight={500}
            gap={5}
        >
            <Heading as="h2" size="xl" textAlign="center">
                Recuperación de contraseña
            </Heading>

            <LockIcon w={14} h={14} color="blue.500" />

            <Text textAlign="center" color="gray.500">
                Ingrese su nueva contraseña
            </Text>

            <form
                onSubmit={handleSubmit}
                style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    gap: 10,
                    minWidth: 500,
                }}
            >
                <CustomInputComponent
                    type="password"
                    placeholder="Contraseña"
                    value={sendData.password}
                    onChange={(value) =>
                        setSendData({ ...sendData, password: value })
                    }
                    leftIcon={LockIcon}
                    errorMessage={validSendData.password}
                />

                <CustomInputComponent
                    type="password"
                    placeholder="Confirmar Contraseña"
                    value={sendData.confirmPassword}
                    onChange={(value) =>
                        setSendData({ ...sendData, confirmPassword: value })
                    }
                    leftIcon={LockIcon}
                    errorMessage={validSendData.confirmPassword}
                />

                <Button
                    leftIcon={<UnlockIcon />}
                    type="submit"
                    isLoading={loading}
                    colorScheme="blue"
                    width={"50%"}
                >
                    Recuperar contraseña
                </Button>
            </form>
        </Flex>
    );
};
